import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Import Font Awesome CSS
import '@fortawesome/fontawesome-free/css/all.min.css';

// Import AOS CSS
import 'aos/dist/aos.css';

// Import Toast CSS
import 'react-toastify/dist/ReactToastify.css';

// Import SweetAlert2 CSS
import 'sweetalert2/dist/sweetalert2.min.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
